define('home/templates/confirmBlacklistUser',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"modal-header\">\n<h4 class=\"modal-title\">"
    + alias2(helpers.gettext.call(alias1,"Ban %(username)s?",{"name":"gettext","hash":{"username":helpers.tag.call(alias1,"b",{"name":"tag","hash":{"text":(depth0 != null ? depth0.username : depth0)},"data":data})},"data":data}))
    + "</h4>\n</div>\n<div class=\"modal-body\">\n<p>"
    + alias2(helpers.gettext.call(alias1,"Click Confirm to ban and remove this user's recent comments and discussions. This user will no longer be able to post comments.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n</div>\n";
},"useData":true})

});
